/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { DocumentRead } from './DocumentRead';
import {
    DocumentReadFromJSON,
    DocumentReadFromJSONTyped,
    DocumentReadToJSON,
    DocumentReadToJSONTyped,
} from './DocumentRead';

/**
 * 
 * @export
 * @interface ListDocumentReadsResponse
 */
export interface ListDocumentReadsResponse {
    /**
     * 
     * @type {Array<DocumentRead>}
     * @memberof ListDocumentReadsResponse
     */
    data: Array<DocumentRead>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDocumentReadsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDocumentReadsResponse interface.
 */
export function instanceOfListDocumentReadsResponse(value: object): value is ListDocumentReadsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDocumentReadsResponseFromJSON(json: any): ListDocumentReadsResponse {
    return ListDocumentReadsResponseFromJSONTyped(json, false);
}

export function ListDocumentReadsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentReadsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(DocumentReadFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDocumentReadsResponseToJSON(json: any): ListDocumentReadsResponse {
      return ListDocumentReadsResponseToJSONTyped(json, false);
  }

  export function ListDocumentReadsResponseToJSONTyped(value?: ListDocumentReadsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(DocumentReadToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

